// Holding summaries/helpers shared by several views.
import type { HoldingRow } from "../core/types";

export const TYPE_PL: Record<string, string> = {
  BUY: "Kupno", SELL: "Sprzedaż", TRANSFER_IN: "Przyjęcie papierów", TRANSFER_OUT: "Wydanie papierów", DEPOSIT: "Wpłata", WITHDRAWAL: "Wypłata",
  CASH_IN: "Przelew wewn. (+)", CASH_OUT: "Przelew wewn. (−)", DIVIDEND: "Dywidenda", INTEREST: "Odsetki", TAX: "Podatek", FEE: "Opłata", ADJUSTMENT: "Korekta",
};

const BOND_KIND: Record<string, string> = { EDO: "Obligacje skarbowe EDO (10-letnie)", COI: "Obligacje skarbowe COI (4-letnie)", ROS: "Obligacje skarbowe ROS (6-letnie)", ROD: "Obligacje skarbowe ROD (12-letnie)" };
export const BOND_KIND_NAME: Record<string, string> = { EDO: "EDO (10-letnie)", COI: "COI (4-letnie)", ROS: "ROS (6-letnie)", ROD: "ROD (12-letnie)" };

/** Holding row; for collapsed bonds — the sum of all series of a given kind. */
export type HoldRow = HoldingRow & { series?: number };

/** Polish treasury bonds: one row per kind (EDO, COI, ...) instead of a row per series. */
export function groupBondRows(rows: readonly HoldingRow[]): HoldRow[] {
  const out: HoldRow[] = [];
  const groups: Record<string, Record<string, unknown>> = {};
  const sumKeys = ["qty", "value", "valueStart", "cost", "flowsPeriod", "incomePeriod", "realizedTotal", "realizedPeriod", "income", "dayChange", "valueT", "costT", "weight", "unrealized", "plPeriod"];
  for (const h of rows) {
    const kind = (h.isin || "").slice(0, 3);
    if (h.assetClass !== "BOND" || !BOND_KIND[kind]) { out.push(h); continue; }
    const g = (groups[kind] ||= { key: "BONDS-" + kind, name: BOND_KIND[kind], isin: "", group: h.group, assetClass: "BOND", symbols: [], listings: [], series: 0 });
    const hr = h as unknown as Record<string, number>;
    for (const k of sumKeys) g[k] = ((g[k] as number) || 0) + (hr[k] || 0);
    g.series = (g.series as number) + 1;
    (g.listings as HoldingRow["listings"]).push(...h.listings);
  }
  for (const g0 of Object.values(groups)) {
    const g = g0 as unknown as HoldRow & { series: number };
    g.symbols = [`${g.series} serii · kliknij, aby rozwinąć`];
    g.unrealizedPct = (g.cost > 0 ? g.value / g.cost - 1 : null) as number;
    g.avgCost = (g.qty > 0 ? g.cost / g.qty : null) as number;
    g.listings = g.listings.length ? [{ ...g.listings[0], price: g.value / g.qty, ccy: "PLN" }] : [];
    out.push(g);
  }
  return out;
}
